Vendd.Scripts.load(function () {

    var handleError = function(error) {

        var _error = error;
        
        if(error instanceof Error)
        {
            // do nothing
        }
        else if(error instanceof String)
        {
            _error = new Error(error);
        }
        else
        {
            try { _error = new Error(error); } catch { }
        }

        console.log(_error);
        console.log(_error.stack);
    };

    var Logger = function() {

    };

    Logger.prototype.init = function() {

        Q.longStackSupport = true;
        Q.onerror = handleError;
    
    };

    Logger.prototype.log = function(error) {

        handleError(error);

    };

    var Vendd = window.Vendd || {};
    Vendd.logger = new Logger();

});